export default "__VITE_ASSET__DEw3oDOM__"